export class ContentTypeModel {
  id: number;
  app_label: string;
  model: string;
}
